export const AbTests = {
  NEW_SAVED_CARD_DESIGN: 'newSavedCardMethodDesignV3',
  BILLIE_DE: 'paymentBillieDE',
  BILLIE_FR: 'paymentBillieFR',
  PROCESSING_CARD_TOGGLE: 'paymentProcessingCardToggle',
  PAYMENT_SUBMIT_DATADOG_LOGS: 'paymentSubmitDatadogLogs',
  HIDE_REASSURANCE_BLOCK: 'hideReassuranceBlock',
};
